import React from 'react';
import { useAuth } from 'react-oidc-context';
import {
  Breadcrumb,
  BreadcrumbItem,
  Content,
  EmptyState,
  EmptyStateBody,
  Icon,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
} from '@patternfly/react-core';
import { NetworkWiredIcon } from '@patternfly/react-icons';
import Unauthenticated from '@app/Unauthenticated';

function Vpn() {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return <Unauthenticated />;
  }

  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem to="/datacenter">Datacenter</BreadcrumbItem>
          <BreadcrumbItem isActive>VPN</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection hasBodyWrapper variant={PageSectionVariants.default} isWidthLimited hasShadowBottom={true}>
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <NetworkWiredIcon />
          </Icon>
          VPN
        </Content>
        <Content component="p">Manage your VPN access</Content>
      </PageSection>
      <PageSection hasBodyWrapper={false}>
        <EmptyState titleText="Coming soon" icon={NetworkWiredIcon} variant="lg" headingLevel="h2">
          <EmptyStateBody>VPN access management is not yet available.</EmptyStateBody>
        </EmptyState>
      </PageSection>
    </>
  );
}

export default Vpn;
